// extracted by mini-css-extract-plugin
export default {"wrapper":"Bill_wrapper__OwPRe","total":"Bill_total__gUDxg","shipping-fee":"Bill_shipping-fee__seTXb","price":"Bill_price__Jf5WG","btn-continue":"Bill_btn-continue__0CIzU"};